import { createSlice } from '@reduxjs/toolkit';

const STORAGE_KEY = 'earniverse_cart';

const savedItems = (() => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
})();

const persistItems = (items) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  } catch {
    // storage unavailable — silent
  }
};

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    items: savedItems,
    isOpen: false,
  },
  reducers: {
    addToCart(state, action) {
      const item = action.payload;
      const exists = state.items.some(
        (i) => i.itemType === item.itemType && String(i.itemId) === String(item.itemId)
      );
      if (!exists) {
        state.items.push(item);
        persistItems(state.items);
      }
    },
    removeFromCart(state, action) {
      const { itemType, itemId } = action.payload;
      state.items = state.items.filter(
        (i) => !(i.itemType === itemType && String(i.itemId) === String(itemId))
      );
      persistItems(state.items);
    },
    clearCart(state) {
      state.items = [];
      persistItems(state.items);
    },
    openCart(state) {
      state.isOpen = true;
    },
    closeCart(state) {
      state.isOpen = false;
    },
  },
});

export const { addToCart, removeFromCart, clearCart, openCart, closeCart } =
  cartSlice.actions;

export const selectCartItems = (state) => state.cart.items;
export const selectCartCount = (state) => state.cart.items.length;
export const selectCartIsOpen = (state) => state.cart.isOpen;
// Returns a number — use formatUSD(selectCartTotal(state)) for display
export const selectCartTotal = (state) =>
  state.cart.items.reduce((sum, item) => sum + parseFloat(item.priceUSD || '0'), 0);

export default cartSlice.reducer;
